import { Component, Output, EventEmitter } from '@angular/core';
import { UserService } from '../services/user.service';
import { userData } from '../../shared/shared.module';
import { environment } from '../../../environments/environment';

@Component({
    moduleId: module.id,
    selector: 'topbar',
    templateUrl: 'topbar.html'
})
export class TopbarComponent {
    userLogged: userData;
    userMenuExpanded: boolean = false;
    env = environment;
    @Output() toggleMenu = new EventEmitter();

    constructor(private userService: UserService) {
        this.userLogged = userService.getUserData();
    }

    doLogout() {
        this.userService
            .logout()
            .then(logoutResponse => {
            });
        return false;
    }

    toggleMenuClick(type: number): void {
        this.toggleMenu.emit(type);
    }

    toggleUserMenu(){
        this.userMenuExpanded = !this.userMenuExpanded;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/masterComponent/topbar.component.ts